module.exports = __webpack_public_path__ + "img/logo-STE.b28cf530.png";